'use client';

import { useEffect } from 'react';

export function HydrationMarker() {
  useEffect(() => {
    // E2E tests use this DOM flag to avoid clicking before client handlers are attached.
    document.documentElement.dataset.hydrated = 'true';
  }, []);

  return null;
}
